import React from "react";
import { FormattedMessage } from "react-intl";

import { INVOICE_MODAL_TYPES } from "@utils/enum";

export const INVOICE_MODAL_CONTENT = {
  [INVOICE_MODAL_TYPES.CONFIRM]: {
    heading: <FormattedMessage id="confirm_invoices" />,
    text: <FormattedMessage id="text_confirm_invoice" />,
    submitButtonLabel: <FormattedMessage id="confirm_invoices" />,
  },
  [INVOICE_MODAL_TYPES.CANCEL]: {
    heading: <FormattedMessage id="cancel_invoices" />,
    text: <FormattedMessage id="text_cancel_invoice" />,
    submitButtonLabel: <FormattedMessage id="cancel_invoices" />,
  },
};
